import React, {useMemo} from "react";
import {useDispatch} from "react-redux";
import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {FiltersIcon, HorizontalListIcon, PropertyPlanIcon, SortIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {BUTTONS_TEST_ID} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {PropertyListType} from "../../../property_list/PropertyListTabSwitcher";
import {useAppSelector} from "../../../store/hooks";
import {trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {setOfferModalType} from "../../state/offer_modals_slice";
import {hitPropertyListViewChange} from "../../tracking/hit_property_list_view_change";
import {IOfferModalName} from "../../types/OfferModalName";

interface IProps {
    openSort: () => void;
    openFilters: () => void;
    modalName: IOfferModalName;
}

export const OfferModalButtons = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useDispatch();
    const propertyListType = useAppSelector((state) => state.offerModals[props.modalName].type);
    const {modalName, openFilters, openSort} = props;
    const filters = useAppSelector((state) => state.offerModals[modalName].filters);
    const offerId = useAppSelector((state) => state.offerModals[modalName].offerId);

    const onTabChange = () => {
        const isSwitchingToFloorPlans = propertyListType === PropertyListType.TABLE;

        trackAmplitudeButtonClick({
            buttonName: "offers_view_toggle",
            value: isSwitchingToFloorPlans ? "floor_plans" : "list",
            buttonCategory: "rp_see_apartments",
            itemId: offerId
        });

        if (isSwitchingToFloorPlans) {
            hitPropertyListViewChange("rzuty");
            dispatch(setOfferModalType({modalName, type: PropertyListType.TILES}));
            return;
        }

        hitPropertyListViewChange("lista");
        dispatch(setOfferModalType({modalName, type: PropertyListType.TABLE}));
    };

    const activeFiltersCount = useMemo(() => {
        if (!filters) {
            return 0;
        }
        const hasRangeValue = (range: {lower: string | number; upper: string | number} | undefined) =>
            range !== undefined && (range.lower !== "" || range.upper !== "");

        const hasFloorsValue = (filters.floor_choices?.length ?? 0) > 0 || (filters.house_storeys?.length ?? 0) > 0;

        return Number(hasRangeValue(filters.price)) + Number(hasRangeValue(filters.rooms)) + Number(hasRangeValue(filters.area)) + Number(hasFloorsValue);
    }, [filters]);

    return (
        <div className={wrapperStyle}>
            <div className={tabButtonsStyle}>
                <StyledButton isActive={propertyListType === "tiles"} onClick={onTabChange}>
                    <PropertyPlanIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                    <Text color="var(--colors-secondary)" variant="button_medium">
                        Rzuty
                    </Text>
                </StyledButton>
                <StyledButton isActive={propertyListType === "table"} onClick={onTabChange}>
                    <HorizontalListIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                    <Text color="var(--colors-secondary)" variant="button_medium">
                        Lista
                    </Text>
                </StyledButton>
            </div>
            {isMobile && (
                <div className={queryButtonsStyle}>
                    <StyledButton isActive onClick={openFilters} data-testid={BUTTONS_TEST_ID.OPEN_FILTERS_BUTTON}>
                        <span className={filtersIconWrapperStyle}>
                            <FiltersIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                            {activeFiltersCount > 0 && (
                                <Badge variant="label_danger" className={filtersBadgeStyle}>
                                    {activeFiltersCount}
                                </Badge>
                            )}
                        </span>
                    </StyledButton>
                    <StyledButton isActive onClick={openSort}>
                        <SortIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                    </StyledButton>
                </div>
            )}
        </div>
    );
};

interface ButtonProps {
    isActive: boolean;
    onClick: () => void;
    children?: React.ReactNode;
    "data-testid"?: string;
}

const StyledButton = ({isActive, onClick, children, "data-testid": dataTestId}: ButtonProps) => (
    <button className={cx(styledButtonStyle, !isActive && styledButtonInactiveStyle)} onClick={onClick} data-testid={dataTestId}>
        {children}
    </button>
);

const wrapperStyle = css({
    display: "flex",
    justifyContent: "space-between",
    flex: "1 1 auto",
    py: 2,
    md: {
        py: 1,
        columnGap: 2
    }
});

const tabButtonsStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 4,
    md: {
        flex: "2 1 auto",
        justifyContent: "flex-end"
    }
});

const styledButtonStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 1
});

const styledButtonInactiveStyle = css({
    opacity: 0.5
});

const queryButtonsStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 3
});

const filtersIconWrapperStyle = css({
    position: "relative",
    display: "inline-flex"
});

const filtersBadgeStyle = css({
    position: "absolute",
    top: -0.5,
    right: -0.5,
    py: "0.25rem",
    px: "0.5rem",
    minHeight: "1.6rem",
    fontSize: "1.6rem",
    lineHeight: 1
});
import React, {useMemo} from "react";
import {useDispatch} from "react-redux";
import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {FiltersIcon, HorizontalListIcon, PropertyPlanIcon, SortIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {BUTTONS_TEST_ID} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {PropertyListType} from "../../../property_list/PropertyListTabSwitcher";
import {useAppSelector} from "../../../store/hooks";
import {trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {setOfferModalType} from "../../state/offer_modals_slice";
import {hitPropertyListViewChange} from "../../tracking/hit_property_list_view_change";
import {IOfferModalName} from "../../types/OfferModalName";

interface IProps {
    openSort: () => void;
    openFilters: () => void;
    modalName: IOfferModalName;
}

export const OfferModalButtons = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useDispatch();
    const propertyListType = useAppSelector((state) => state.offerModals[props.modalName].type);
    const {modalName, openFilters, openSort} = props;
    const filters = useAppSelector((state) => state.offerModals[modalName].filters);
    const offerId = useAppSelector((state) => state.offerModals[modalName].offerId);

    const onTabChange = () => {
        const isSwitchingToFloorPlans = propertyListType === PropertyListType.TABLE;

        trackAmplitudeButtonClick({
            buttonName: "offers_view_toggle",
            value: isSwitchingToFloorPlans ? "floor_plans" : "list",
            buttonCategory: "rp_see_apartments",
            itemId: offerId
        });

        if (isSwitchingToFloorPlans) {
            hitPropertyListViewChange("rzuty");
            dispatch(setOfferModalType({modalName, type: PropertyListType.TILES}));
            return;
        }

        hitPropertyListViewChange("lista");
        dispatch(setOfferModalType({modalName, type: PropertyListType.TABLE}));
    };

    const activeFiltersCount = useMemo(() => {
        if (!filters) {
            return 0;
        }
        const hasRangeValue = (range: {lower: string | number; upper: string | number} | undefined) =>
            range !== undefined && (range.lower !== "" || range.upper !== "");

        const hasFloorsValue = (filters.floor_choices?.length ?? 0) > 0 || (filters.house_storeys?.length ?? 0) > 0;

        return Number(hasRangeValue(filters.price)) + Number(hasRangeValue(filters.rooms)) + Number(hasRangeValue(filters.area)) + Number(hasFloorsValue);
    }, [filters]);

    return (
        <div className={wrapperStyle}>
            <div className={tabButtonsStyle}>
                <StyledButton isActive={propertyListType === "tiles"} onClick={onTabChange}>
                    <PropertyPlanIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                    <Text color="var(--colors-secondary)" variant="button_medium">
                        Rzuty
                    </Text>
                </StyledButton>
                <StyledButton isActive={propertyListType === "table"} onClick={onTabChange}>
                    <HorizontalListIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                    <Text color="var(--colors-secondary)" variant="button_medium">
                        Lista
                    </Text>
                </StyledButton>
            </div>
            {isMobile && (
                <div className={queryButtonsStyle}>
                    <StyledButton isActive onClick={openFilters} data-testid={BUTTONS_TEST_ID.OPEN_FILTERS_BUTTON}>
                        <span className={filtersIconWrapperStyle}>
                            <FiltersIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                            {activeFiltersCount > 0 && (
                                <Badge variant="label_danger" className={filtersBadgeStyle}>
                                    {activeFiltersCount}
                                </Badge>
                            )}
                        </span>
                    </StyledButton>
                    <StyledButton isActive onClick={openSort}>
                        <SortIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-secondary)" />
                    </StyledButton>
                </div>
            )}
        </div>
    );
};

interface ButtonProps {
    isActive: boolean;
    onClick: () => void;
    children?: React.ReactNode;
    "data-testid"?: string;
}

const StyledButton = ({isActive, onClick, children, "data-testid": dataTestId}: ButtonProps) => (
    <button className={cx(styledButtonStyle, !isActive && styledButtonInactiveStyle)} onClick={onClick} data-testid={dataTestId}>
        {children}
    </button>
);

const wrapperStyle = css({
    display: "flex",
    justifyContent: "space-between",
    flex: "1 1 auto",
    py: 2,
    md: {
        py: 1,
        columnGap: 2
    }
});

const tabButtonsStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 4,
    md: {
        flex: "2 1 auto",
        justifyContent: "flex-end"
    }
});

const styledButtonStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 1
});

const styledButtonInactiveStyle = css({
    opacity: 0.5
});

const queryButtonsStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 3
});

const filtersIconWrapperStyle = css({
    position: "relative",
    display: "inline-flex"
});

const filtersBadgeStyle = css({
    position: "absolute",
    top: -0.5,
    right: -0.5,
    py: "0.25rem",
    px: "0.5rem",
    minHeight: "1.6rem",
    fontSize: "1.6rem",
    lineHeight: 1
});
